import { Link } from "@tanstack/react-router";

import { cn } from "@/lib/utils";

import type { UserType } from "./types";

interface CounterItemButtonProps {
  href: string;
  label: string;
  value: number;
}

function CounterItemButton({ href, label, value }: CounterItemButtonProps) {
  return (
    <li className="relative flex h-[41px] items-center justify-center gap-1.5 rounded-[5px] bg-white/5 text-14 leading-[1.2em] transition-colors hover:bg-white/8 md:h-[37px]">
      <strong className="font-semibold text-white">{value}</strong>
      <Link
        className="link-overlay text-heather md:text-pale-lavender"
        to={href}
      >
        {label}
      </Link>
    </li>
  );
}

interface CountersButtonsProps {
  className?: string;
  user: UserType;
}

export default function CountersButtons({
  className,
  user,
}: CountersButtonsProps) {
  return (
    <ul className={cn("mt-[15px] grid grid-cols-2 gap-2 md:mt-0", className)}>
      <CounterItemButton
        href={`/@${user.username}/wishlist`}
        label="Wishlisted"
        value={user.wishlistedCount || 0}
      />
      <CounterItemButton
        href={`/@${user.username}/reviews`}
        label="Reviewed"
        value={user.reviewsCount || 0}
      />
    </ul>
  );
}
